import { gql } from '@apollo/client';

import { CAREER_PROFILE_FIELDS } from '../fragments/careerProfile';

/**
 * Career profile writes (spec 0018, increment B).
 *
 * Operation names are deliberately distinct from the backend field names
 * (`SaveCareerProfileForm` vs `saveCareerProfile`)
 * — equal names collapse the generated result type (graphql-codegen skill).
 *
 * `saveCareerProfile` has delete-and-recreate semantics for most collections: the
 * client always sends the FULL collections (skills / projects / experience /
 * education / languages), never a delta. Certificates are the exception — they are
 * reconciled by `id` (see the CareerProfileFields fragment / transformProfileToInput).
 *
 * The mutation returns the FULL profile (fragment) so the caller can use the
 * response as the new form baseline without a refetch that would clobber edits
 * typed while the save was in flight.
 */
export const SaveCareerProfileFormMutation = gql`
  ${CAREER_PROFILE_FIELDS}
  mutation SaveCareerProfileForm(
    $input: CareerProfileInput!
    $photo: Upload
    $clearPhoto: Boolean
  ) {
    saveCareerProfile(input: $input, photo: $photo, clearPhoto: $clearPhoto) {
      success
      customErrors {
        field
        message
        code
      }
      profile {
        ...CareerProfileFields
      }
    }
  }
`;

/**
 * Partner-search opt-in (spec 0018 §3.1 — `is_searchable` defaults to false).
 * `contactsVisible` is a second, dependent consent.
 */
export const SetProfileSearchableMutation = gql`
  mutation SetProfileSearchable($isSearchable: Boolean!, $contactsVisible: Boolean) {
    setProfileSearchable(isSearchable: $isSearchable, contactsVisible: $contactsVisible) {
      success
      customErrors {
        field
        message
        code
      }
      profile {
        id
        isSearchable
        contactsVisible
      }
    }
  }
`;

/**
 * Самооценка уровня навыка (0072) — из паспорта навыка на карте. Подтверждённый
 * школой уровень сервер не понижает.
 */
export const SetMySkillLevelMutation = gql`
  mutation SetMySkillLevelChoice($skillId: ID!, $level: Int!) {
    setMySkillLevel(skillId: $skillId, level: $level) {
      success
      customErrors {
        field
        message
        code
      }
      skill {
        skillId
        level
        source
      }
    }
  }
`;
